import {
  skeletonBar,
  skeletonBentoCell,
  skeletonBentoGrid,
  skeletonContainer,
  skeletonContentPadding,
  skeletonDesktopHeader,
  skeletonGalleryContainer,
  skeletonGalleryPadding,
  skeletonHeaderBarCenter,
  skeletonHeaderBarLeft,
  skeletonHeaderBarRight,
  skeletonMain,
  skeletonMobileCarousel,
} from './haloListingPageSkeleton.styles';

export const HaloListingPageSkeleton = () => (
  <div className={skeletonContainer} aria-busy="true" aria-label="Loading property details">
    <main className={skeletonMain}>
      {/* Desktop sticky header placeholder */}
      <div className={skeletonDesktopHeader}>
        <div className={skeletonHeaderBarLeft} />
        <div className={skeletonHeaderBarCenter} />
        <div className={skeletonHeaderBarRight} />
      </div>

      <div className={skeletonGalleryPadding}>
        <div className={skeletonGalleryContainer}>
          {/* Mobile: carousel placeholder */}
          <div className={skeletonMobileCarousel} />

          {/* Desktop: bento grid placeholder */}
          <div className={skeletonBentoGrid}>
            <div className={skeletonBentoCell} />
            <div className={skeletonBentoCell} />
            <div className={skeletonBentoCell} />
            <div className={skeletonBentoCell} />
          </div>
        </div>
      </div>

      <div className={skeletonContentPadding}>
        <div className={skeletonBar} style={{ width: '55%', height: '22px' }} />
        <div className={skeletonBar} style={{ width: '35%' }} />
        <div className={skeletonBar} style={{ width: '25%', height: '20px', marginTop: 16 }} />
        <div className={skeletonBar} style={{ width: '70%', marginTop: 16 }} />
        <div className={skeletonBar} style={{ width: '60%' }} />
      </div>
    </main>
  </div>
);
